module.exports = __webpack_public_path__ + "6439be2bdd501b730cb97781d309a9b5.MP3";